import React from 'react'

import PlaylistCard from 'app/VideoRepository/components/PlaylistCard'

import type { Playlists as PlaylistsType } from 'types/video-inspirasi'

interface PlaylistsProps {
  playlists: PlaylistsType[]
}

const PlaylistsList = ({ playlists }: PlaylistsProps) => {
  return (
    <div>
      {playlists.map(
        (
          { id, bannerImageUrl, name, videoCount, shortDescription, reviewer },
          index
        ) => (
          <PlaylistCard
            id={id}
            key={index}
            bannerImageUrl={bannerImageUrl}
            name={name}
            videoCount={videoCount}
            shortDescription={shortDescription}
            reviewer={reviewer}
          />
        )
      )}
    </div>
  )
}

export default PlaylistsList
